import DateAnnotation from "@shared/models/date-annotation"
import Patch from "@shared/models/patch-updater"
import _ from "lodash"

export default {
  name: "COURSE_DATE_TEMPLATE_TOGGLE",

  params: {
    isOn: "string",
    course: "object",
    rotationId: "string",
    semesterId: "string",
  },

  patches(payload) {
    let hasDateAnnotation = _.find(
      payload.course.attributes.calendar.dateAnnotations,
      (annotation) => {
        return (
          annotation.type === "date-annotation-course-default" &&
          annotation.attributes.rotationId === payload.rotationId &&
          annotation.attributes.semesterId === payload.semesterId
        )
      }
    )
    let annotation
    if (hasDateAnnotation === undefined) {
      annotation = new DateAnnotation({
        id: `${payload.semesterId}:${payload.rotationId}`,
        type: "date-annotation-course-default",
        attributes: {
          rotationId: payload.rotationId,
          semesterId: payload.semesterId,
          isOff: !payload.isOn,
        },
      })
    } else {
      annotation = hasDateAnnotation
    }

    let patch

    if (hasDateAnnotation) {
      patch = Patch.create("course", payload.course.id, "attributes.calendar.dateAnnotations", {
        id: `${payload.semesterId}:${payload.rotationId}`,
      }).set("embedded", "attributes.isOff", !payload.isOn)
    } else {
      patch = Patch.create("course", payload.course.id).push(
        "attributes.calendar.dateAnnotations",
        annotation
      )
    }

    if (payload.isOn) {
      patch.pull("attributes.calendar.datesOff", `${payload.semesterId}:${payload.rotationId}`)
    } else {
      patch.addToSet("attributes.calendar.datesOff", `${payload.semesterId}:${payload.rotationId}`)
    }

    return [patch.patch]
  },

  narrative(payload, findFn, userId) {
    let course = findFn("course", _.get(payload, "courseId"))
    let rotationCalendar = findFn(
      "rotation-calendar",
      _.get(course, "relationships.rotationCalendar.data.id")
    )
    let planbook = findFn("planbook", _.get(course, "relationships.planbook.data.id"))

    // Find the rotationCalendar
    // Find the title of the rotation
    let onOff = payload.isOff === true ? "Off" : "On"
    let rotation = _.find(rotationCalendar, { id: payload.rotationId })
    let title = _.get(rotation, "title")

    return {
      title: `Toggle Class ${onOff}`,
      titleForAnalytics: "Course - Toggle Template Date",
      description: `Toggle all courses on that happen on ${title} to be ${onOff}`,
      context: {
        courseTitle: course.attributes.title,
        planbookTitle: planbook.attributes.title,
        courseId: course.id,
        planbookId: planbook.id,
      },
      activity: {
        actor: `user-${userId}`,
        verb: "edited",
        object: `course-${course.id}`,
        to: [`course-edits:course-${course.id}`, `planbook-edits:planbook-${planbook.id}`],
      },
    }
  },
}
